import './Footer.scss';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <p className="footer__text">©{currentYear} ALINA POLONEYEVA</p>
      </div>
    </footer>
  );
};

export default Footer;